import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ReadyToGetStarted() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="ready-to-get-started" className="dark bg-background text-foreground">
      <div ref={ref} className={cn("w-full py-20 bg-gradient-to-r from-primary via-primary to-chart-3", "transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="container mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
            <div className="max-w-3xl space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-primary-foreground">
                Looking for Reliable Commercial Cleaning?
              </h2>
              <p className="text-lg md:text-xl text-primary-foreground/90 font-medium max-w-2xl">
                Partner with Gold Star Executive Cleaning for professional, high-quality service across Newcastle, the Central Coast, and Sydney.
              </p>
            </div>
            <div className="flex-shrink-0 pt-4 md:pt-0">
              <Button asChild size="lg" className="bg-black text-white hover:bg-neutral-800 border-none shadow-2xl text-base px-8 py-7 h-auto rounded-full transition-transform hover:scale-105">
                <Link to="/ContactUsPage">
                  Get a Free Quote
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}